import React, { useEffect, useState } from "react";
import { api, errorMessage } from "../../lib/api";
import StatsCard from "../../components/StatsCard";
import PipelineSummary from "../../components/PipelineSummary";
import { FileText, Clock, CheckCircle2, Users } from "lucide-react";
import { toast } from "sonner";
import { PurgeTestDataCard } from "../../components/PurgeTestDataCard";

export default function AdminDashboard() {
  const [data, setData] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/dashboard");
      setData(data);
    } catch (e) {
      toast.error(errorMessage(e));
    }
  };

  useEffect(() => { load(); }, []);

  if (!data) return <div className="text-sm text-slate-400">Loading…</div>;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight">Dashboard</h1>
        <p className="mt-1 text-sm text-slate-400">Portfolio snapshot across all brokers.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatsCard label="Total Applications" value={data.stats.total_applications} icon={FileText} accent="emerald" testId="admin-stat-total" />
        <StatsCard label="Pending Review" value={data.stats.pending_review} icon={Clock} accent="amber" testId="admin-stat-pending" />
        <StatsCard label="Approved" value={data.stats.approved} icon={CheckCircle2} accent="emerald" testId="admin-stat-approved" />
        <StatsCard label="Active Brokers" value={data.stats.active_brokers} icon={Users} accent="blue" testId="admin-stat-brokers" />
      </div>
      <PipelineSummary
        pipeline={data.pipeline}
        extraStages={[{ key: "denied", label: "Denied" }]}
      />
      <PurgeTestDataCard onDone={load} />
    </div>
  );
}
